import React from 'react'
import './footer.sass'

export default () => (
  <footer className="footer">
    <span className="copyright">© 2019 Tyler Drake. All rights reserved.</span>
  </footer>
)
